export class TechStack extends HTMLElement {
  constructor() {
    super();
    this.row1Track = null;
    this.row2Track = null;
  }

  connectedCallback() {
    this.row1Track = this.querySelector('.tech-stack__logos-track--row1');
    this.row2Track = this.querySelector('.tech-stack__logos-track--row2');
    
    this.initAnimations();
  }

  initAnimations() {
    // Row 1 Animation
    if (this.row1Track) {
      const row1Speed = parseFloat(this.dataset.row1Speed) || 30;
      const row1Direction = this.dataset.row1Direction || 'left';
      const row1AnimationName = row1Direction === 'right' ? 'tech-stack-scroll-right' : 'tech-stack-scroll-left';
      
      this.row1Track.style.animationName = row1AnimationName;
      this.row1Track.style.animationDuration = `${row1Speed}s`;
      this.row1Track.style.animationTimingFunction = 'linear';
      this.row1Track.style.animationIterationCount = 'infinite';
    }

    // Row 2 Animation
    if (this.row2Track) {
      const row2Speed = parseFloat(this.dataset.row2Speed) || 40;
      const row2Direction = this.dataset.row2Direction || 'right';
      const row2AnimationName = row2Direction === 'right' ? 'tech-stack-scroll-right' : 'tech-stack-scroll-left';
      
      this.row2Track.style.animationName = row2AnimationName;
      this.row2Track.style.animationDuration = `${row2Speed}s`;
      this.row2Track.style.animationTimingFunction = 'linear';
      this.row2Track.style.animationIterationCount = 'infinite';
    }
  }

  disconnectedCallback() {
    if (this.row1Track) {
      this.row1Track.style.animationName = 'none';
    }
    if (this.row2Track) {
      this.row2Track.style.animationName = 'none';
    }
  }
}

if (!customElements.get('tech-stack')) {
  customElements.define('tech-stack', TechStack);
}
